import React from "react";
import {  Link } from "react-router-dom";
function Footer() {
  const linkAboutus = [
    {
      title: "Giới thiệu về Mandala",
      path: "",
    },
    { title: "Tuyển dụng", path: "" },
    {
      title: "Đánh giá",
      path: "",
    },
  ];
  const linkSupport = [
    {
      title: "FAQ",
      path: "/faqs",
    },
    {
      title: "Liên hệ",
      path: "/contact",
    },
    {
      title: "Chính sách",
      path: "/policy",
    },
  ];
  const appStore = [
    {
      image: "/images/ic_app_store.png",
      path: "",
    },
    {
      image: "/images/ic_google_play.png",
      path: "",
    },
  ];
  const linkSocial = [
    {
      icon: "/images/ic_fb.png",
      path: "",
    },
    {
      icon: "/images/ic_ins.png",
      path: "",
    },
    {
      icon: "/images/ic_tw.png",
      path: "",
    },
  ];
  return (
    <div id="footer">
      <div className="container">
        <div className="footerTop">
          <div className="row">
            <div className="col-lg-4 col-12 col-md-4">
              <h5 className="title">Trụ sở chính</h5>
              <p>
                <Link to="/">
                  Tầng 3, TTTM Grand Plaza, số 117 Trần Duy Hưng, P. Trung
                  Hòa, Q. Cầu Giấy, Hà Nội
                </Link>
              </p>
              <p>
                <span>SĐT. </span>
                <Link to="/">0222 386 88 66</Link>
              </p>
              <p>
                <span>Email. </span>
                <Link to="/">welcome@mandalahotel.com.vn</Link>
              </p>
            </div>
            <div className="col-lg-3  col-12 col-md-3">
              <h5 className="title">Về Mandala</h5>
              <ul className="linkList">
                {linkAboutus.map((item, index) => {
                  return (
                    <li>
                      <Link to={item.path}>{item.title}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-lg-3 col-12  col-md-3">
              <h5 className="title">HỖ TRỢ</h5>
              <ul className="linkList">
                {linkSupport.map((item, index) => {
                  return (
                    <li>
                      <Link to={item.path}>{item.title}</Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-lg-2 col-12 col-md-2 appStore">
              <h5 className="title">TẢI APP Mandala</h5>
              <ul>
                {appStore.map((item, index) => {
                  return (
                    <li>
                      <Link to={item.path}>
                        <img className="img-fluid" src={item.image} alt="" />
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        <div className="footerBottom">
          <div className="row">
            <div className="col-lg-6 col-12  col-md-6 formCol">
              <div className="copyright">
                <img className="img-fluid logo" src="/images/logo.png" alt="" />
                <span>Copyright @2020 MandalaHotel</span>
              </div>
            </div>
            <div className="col-lg-6 col-12 col-md-6">
              <div className="row footerBottomRow">
                <div className="col-lg-6 col-12 col-md-6 formCol certificate">
                  <img
                    className="img-fluid"
                    src="/images/logo_ads.png"
                    alt=""
                  />
                </div>
                <div className="col-lg-6 col-12 col-md-6 formCol linkSocial">
                  <ul>
                    {linkSocial.map((item, index) => {
                      return (
                        <li>
                          <Link to={item.path}>
                            <img
                              className="img-fluid"
                              src={item.icon}
                              alt=""
                            />
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
